import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Cropper from 'react-easy-crop';
//
import { getCroppedImg } from '@/utils';
import { Box, Button, Slider, Typography } from '@mui/material';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  setOpen: (open: boolean) => void;
  imgSrc: string;
  aspect?: number;
  cropped: any;
  setCropped: (cropped: any) => void;
  onConfirm: () => void;
}

export default function CropUpload({
  open,
  setOpen,
  cropped,
  setCropped,
  aspect,
  onConfirm,
  imgSrc,
}: Props) {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [height, setHeight] = React.useState(300);
  const [width, setWidth] = React.useState(300);
  const [scale, setScale] = React.useState(1);
  const [rotate, setRotate] = React.useState(0);
  const [customAspect, setCustomAspect] = React.useState(aspect);

  React.useEffect(() => {
    if (height !== 0) {
      setCustomAspect(width / height);
    }
  }, [height, width]);

  const onCropComplete = async (croppedArea: any, croppedAreaPixels: any) => {
    try {
      const croppedImage = await getCroppedImg(
        imgSrc,
        croppedAreaPixels,
        rotate
      );
      setCropped(croppedImage as string);
    } catch (e) {
      console.error("Couldn't create cropped image");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="adTitle"
        aria-describedby="adDesc"
        maxWidth="lg"
      >
        <DialogTitle id="adTitle">Customize your image</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              columnGap: 2,
            }}
          >
            <Box style={{ flex: 1 }}>
              <Box
                sx={{
                  width: 500,
                  height: 350,
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #999',
                  background: '#ccc',
                }}
              >
                {!!imgSrc && (
                  <Cropper
                    image={imgSrc}
                    crop={crop}
                    zoom={scale}
                    minZoom={1}
                    maxZoom={3}
                    aspect={customAspect}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setScale}
                    rotation={rotate}
                  />
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  px: 1,
                  mt: 2,
                }}
              >
                {/* <ZoomIn /> */}
                <Slider
                  disabled={!imgSrc}
                  value={scale}
                  step={0.1}
                  min={1}
                  max={3}
                  aria-labelledby="Zoom"
                  valueLabelDisplay="off"
                  onChange={(e, v) => setScale(v as number)}
                />
              </Box>
            </Box>
            <Box sx={{ width: 200 }}>
              <div>
                <Box>
                  <Typography variant="caption" display="block">
                    Rotate:
                  </Typography>
                  <Slider
                    style={{ height: 2 }}
                    value={rotate}
                    step={5}
                    min={0}
                    max={180}
                    valueLabelDisplay="off"
                    onChange={(e, v) => setRotate(v as number)}
                  />
                  {/* <Box sx={{ display: 'inline-flex', columnGap: 1 }}>
                    <IconButton onClick={() => setRotate(rotate + 90)}>
                      <Rotate90DegreesCcw />
                    </IconButton>
                    <IconButton onClick={() => setRotate(0)}>
                      <Rotate90DegreesCcw sx={{ transform: 'rotate(90deg)' }} />
                    </IconButton>
                    <IconButton onClick={() => setRotate(rotate - 90)}>
                      <Rotate90DegreesCcw
                        sx={{ transform: 'rotate(180deg)' }}
                      />
                    </IconButton>
                  </Box> */}
                </Box>

                <Box
                  mt={1}
                  sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
                >
                  <Box flex={1}>
                    <Typography variant="caption">Width:</Typography>
                    <Slider
                      style={{ height: 2 }}
                      value={width}
                      step={10}
                      min={100}
                      max={800}
                      valueLabelDisplay="off"
                      onChange={(e, v) => setWidth(v as number)}
                      disabled={!!aspect}
                    />
                  </Box>
                  <Box flex={1}>
                    <Typography variant="caption">Height:</Typography>
                    <Slider
                      style={{ height: 2 }}
                      value={height}
                      step={10}
                      min={100}
                      max={800}
                      valueLabelDisplay="off"
                      onChange={(e, v) => setHeight(v as number)}
                      disabled={!!aspect}
                    />
                  </Box>
                </Box>

                {!!cropped && (
                  <>
                    <Typography variant="caption" display="block" mt={1} mb={1}>
                      Croped Preview:
                    </Typography>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        height: 150,
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid #999',
                        background: '#ccc',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundImage: `url(${cropped})`,
                      }}
                    />
                  </>
                )}
              </div>

              <Button
                variant="contained"
                type="submit"
                sx={{
                  minWidth: '100%',
                  marginTop: 'auto',
                  my: 2,
                }}
                // disabled={isSubmitting || (isLast && (hasErr || error))}
                onClick={onConfirm}
              >
                Confirm
                {/* {currentStep.step === stepsArray.length - 1
                ? 'Agree & submit'
                : 'Continue'}{' '}
              {isSubmitting ? (
                <div style={{ marginLeft: 10 }}>
                  <ClockLoader size={20} color="#999" />
                </div>
              ) : (
                <ArrowForward fontSize="small" sx={{ ml: 1 }} />
              )} */}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
